export function printURL(pdf_url: any) {
  var iframe = document.getElementById("vc_local_print");
  if (iframe !== null) {
    document.body.removeChild(iframe);
  }

  // recreate iframe everytime to reliably display print dialog
  iframe = document.createElement("iframe");
  iframe.id = "vc_local_print";
  iframe.style.display = "none";
  iframe.addEventListener("load", function () {
    if ((iframe as any).src === "" || (iframe as any).src === "about:blank") {
      return;
    }

    let style = document.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML =
      "@page{size:auto;}\n img{width:100%; height:auto;}";

    if ((iframe as any).contentDocument?.head) {
      (iframe as any).contentDocument.head.appendChild(style);
    } else if ( (iframe as any).contentDocument?.body ) {
      (iframe as any).contentDocument.body.appendChild(style);
    } 
    
    (iframe as any).contentWindow.print();
  });
  document.body.appendChild(iframe);
  (iframe as any).src = pdf_url;
}

export async function printPDFFixedSecurity(base64Data: string) {
  try {
    const base64Content = base64Data.includes(",") 
      ? base64Data.split(",")[1] 
      : base64Data;

    const byteCharacters = atob(base64Content);
    const byteNumbers = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    
    const blob = new Blob([byteNumbers], { type: 'application/pdf' });
    const blobURL = URL.createObjectURL(blob);

    // --- ส่วนที่ปรับปรุง: จัดการ Iframe และล้าง Memory ของเก่า ---
    const oldIframe = document.getElementById("scanned-doc-pdf-print-container") as HTMLIFrameElement;
    if (oldIframe) {
      // คืนค่า Memory ของ URL เก่าก่อนจะลบ iframe ทิ้ง
      if (oldIframe.src.startsWith('blob:')) {
        URL.revokeObjectURL(oldIframe.src);
      }
      document.body.removeChild(oldIframe);
    }
    // ------------------------------------------------------

    const iframe = document.createElement("iframe");
    iframe.id = "scanned-doc-pdf-print-container";
    
    Object.assign(iframe.style, {
      position: "fixed",
      left: "-10000px",
      top: "0",
      width: "100%", 
      height: "100%",
      border: "none"
    });
      
    iframe.onload = () => {
      if (!iframe.contentWindow) return;
      setTimeout(() => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
        // ไม่ต้องใส่ cleanup ตรงนี้ เพื่อให้เลือก Paper Size ได้อิสระ
      }, 500);
    };

    document.body.appendChild(iframe);
    iframe.src = blobURL; // ผูก URL ใหม่เข้าไป

  } catch (error) {
    console.error("Print Error:", error);
  }
}

export const b64toBlob = (base64, type = 'application/pdf') => 
  fetch(`data:${type};base64,${base64}`).then(res => res.blob())

export const  printBase64  =  async (base64: string) => { 
  var iframe: any = document.getElementById("vc_local_print");
  if (iframe !== null) {
    document.body.removeChild(iframe);
  }
  
  // recreate iframe everytime to reliably display print dialog
  iframe = document.createElement("iframe");
  iframe.id = "vc_local_print";
  iframe.style.display = "none";
  iframe.addEventListener("load", function () {
    if (iframe.src === "" || iframe.src === "about:blank") {
      return;
    }
    iframe.contentWindow.print();
  });
  document.body.appendChild(iframe);

  // ทำ blob เข้า url TODO: เลิกใช้ atob
  // const contentType = "application/pdf";
  // const byteCharacters = Buffer.from(base64 ,'base64');
  // const byteNumbers = new Array(byteCharacters.length);
  // for (let i = 0; i < byteCharacters.length; i++) {
  //   byteNumbers[i] = byteCharacters.charCodeAt(i);
  // }
  // const byteArray = new Uint8Array(byteNumbers);
  // const blob = new Blob([byteArray], {
  //   type: contentType,
  // });
  let blob = await b64toBlob(base64)
  const blobUrl = URL.createObjectURL(blob);
  
  iframe.src = blobUrl;
}


export const fetchURLToBase64 = async (url) => {
  // Fetch the image or file from the provided URL
  const response = await fetch(url);

  // Ensure the response is OK (status 200)
  if (!response.ok) {
    throw new Error(`Failed to fetch the file: ${response.statusText}`);
  }

  // Get the response as a Blob
  const blob = await response.blob();

  // Convert the Blob to a base64 string
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob); // Convert blob to data URL
  });
}



/// Unused Code just test
function test() {
  var iframe = document.getElementById("vc_local_print");
  if (iframe !== null) {
    document.body.removeChild(iframe);
  }

  // recreate iframe everytime to reliably display print dialog
  iframe = document.createElement("iframe");
  iframe.id = "vc_local_print";
  iframe.style.display = "none";

  document.body.appendChild(iframe);
  (iframe as any).src = "http://localhost:3000/static/images/ff13e72f-2ca.jpg";
  // Pause

  var style = document.createElement("style");
  style.setAttribute("type", "text/css");
  style.innerHTML =
    "@page{size:auto; margin:0mm;}\n img{width:100%; height:auto;}";

  (iframe as any).contentDocument.head.appendChild(style);

  if ((iframe as any).src === "" || (iframe as any).src === "about:blank") {
    return;
  }
  (iframe as any).contentWindow.print();
}

export const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const base64ToUint8Array = (base64: string) => {
  const byteChars = atob(base64);
  const byteNumbers = new Array(byteChars.length);

  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }

  return new Uint8Array(byteNumbers);
};

export const base64ToObjectURL = (base64: string): string => {
  const base64Data = base64.replace(/^data:application\/pdf;base64,/, "");
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });
  return URL.createObjectURL(blob);
};

export const isIOS = (): boolean => {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};
